export default __webpack_public_path__ + "static/media/BG-Red-0000.6bbdb766.png";